'use strict';

import $ from 'jquery';
import Swal from 'sweetalert2';
import 'bootstrap';
import { modalSaveReport } from '../../modules/modalSaveReport';

const lang = document.documentElement.lang;
const tr = {
  'pt-BR': {
    modal_error_title: 'Atenção!',
    modal_error_activity: 'Preencha pelo menos 1 item de Atividade!',
    modal_error_description: 'Preencha a descrição!',
    modal_error_make_donation: 'Informe se você fez doação!',
    modal_error_item_donation: 'Preencha pelo menos 1 item de doação!',
    modal_error_fields: 'Preencha os campos corretamente',
  },
  es: {
    modal_error_title: '¡Atención!',
    modal_error_activity: '¡Completa al menos 1 elemento de actividad!',
    modal_error_description: '¡Completa la descripción!',
    modal_error_make_donation: '¡Por favor, infórmanos si hiciste una donación!',
    modal_error_item_donation: '¡Por favor complete al menos 1 artículo de donación!',
    modal_error_fields: 'Rellena los campos correctamente',
  },
  en: {
    modal_error_title: 'Warning!',
    modal_error_activity: 'Check at least one activity to proceed.',
    modal_error_description: 'Fill in the description!',
    modal_error_make_donation: 'Please let us know if you made a donation!',
    modal_error_item_donation: 'Please complete at least 1 donation item!',
    modal_error_fields: 'Please fill out all the fields correctly',
  },
};

const reportactivities = {
  init() {
    const $form = document.getElementById('form');

    modalSaveReport(validateFields);

    $form.addEventListener('submit', e => {
      e.preventDefault();

      console.log('sending form');

      if (validateFields()) e.target.submit();
    });

    function validateFields() {
      let isValid = true;
      let count = 0;

      $('input[type="checkbox"]:checked', $form).each(function (_index, el) {
        if (el.value.length > 0) {
          count++;
        }
      });

      if (count <= 0) {
        Swal.fire({
          icon: 'error',
          title: tr[lang].modal_error_title,
          text: tr[lang].modal_error_activity,
        });

        isValid = false;
      }

      if (!$('[name="activities_description"]', $form).val()) {
        Swal.fire({
          icon: 'error',
          title: tr[lang].modal_error_title,
          text: tr[lang].modal_error_description,
        });

        isValid = false;
      }

      return isValid;
    }
  },
};

const _this = reportactivities;

export default _this;
